import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.marciamonteirowellness.com';
const DEFAULT_TITLE = 'Márcia Monteiro Wellness';
const DEFAULT_DESCRIPTION = 'Márcia Monteiro Wellness em Gondifelos: Yoga, Pilates, massagens e terapias holísticas com acompanhamento personalizado para o seu bem-estar.';
const DEFAULT_IMAGE = `${SITE_URL}/branding/og-cover.png`;

function setMeta(attr, key, content) {
  const tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (tag) tag.setAttribute('content', content);
}

function setCanonical(href) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

// Define o <title>, a meta description, o canonical e as tags og: da página
// atual. Não é SSR (o Google indexa via execução de JS, mas partilhas em redes
// sociais como WhatsApp/Facebook não executam JS e continuam a usar as tags
// og: estáticas do index.html na primeira partilha de um link).
export default function Seo({ title, description, image }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const fullTitle = title ? `${title} | Márcia Monteiro Wellness` : DEFAULT_TITLE;
    const fullDescription = description || DEFAULT_DESCRIPTION;
    const fullImage = image || DEFAULT_IMAGE;
    const canonicalUrl = `${SITE_URL}${pathname === '/' ? '' : pathname.replace(/\/+$/, '')}`;

    document.title = fullTitle;
    setMeta('name', 'description', fullDescription);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', fullDescription);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:image', fullImage);
    setMeta('property', 'og:image:secure_url', fullImage);
    setCanonical(canonicalUrl);

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('name', 'description', DEFAULT_DESCRIPTION);
      setMeta('property', 'og:title', DEFAULT_TITLE);
      setMeta('property', 'og:description', DEFAULT_DESCRIPTION);
      setMeta('property', 'og:url', SITE_URL);
      setMeta('property', 'og:image', DEFAULT_IMAGE);
      setMeta('property', 'og:image:secure_url', DEFAULT_IMAGE);
    };
  }, [title, description, image, pathname]);

  return null;
}
